import { observable, configure } from 'mobx';
import LocalModel from './localModel';

import util from 'preact-util';

configure({ enforceActions: 'always' });

class RubicCardStore extends LocalModel {
    constructor() {
        super('rubicCard', {
            namePlural: 'rubicCards',
            namePluralReal: 'rubiccards',
            api: { load: { url: '/api/integrations/rubic/my-startcard', params: {} } },
        });
    }

    @observable startCard = {};

    @observable loading = false;

    @observable error = '';

    async getMyStartCard(customer) {
        this.updateKeyValue('loading', true);
        this.updateKeyValue('error', '');
        const qs = customer ? `?customer=${customer}` : '';
        const response = await util.fetchApi(`/api/integrations/rubic/my-startcard${qs}`, { method: 'GET' });
        if (response.status === 200) {
            this.updateKeyValue('startCard', response.data || {});
        } else {
            this.updateKeyValue('error', (response && response.message) || 'Could not load start card');
        }
        this.updateKeyValue('loading', false);
        return response;
    }
}

const store = new RubicCardStore();
export default store;
